export { Price } from "./price.component";
